var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcnTypeDotButton = function SvgIcnTypeDotButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#292929",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 4.506C15.046 4.506 4.506 15.046 4.506 28S15.046 51.494 28 51.494 51.494 40.954 51.494 28 40.954 4.506 28 4.506M28 55C13.112 55 1 42.888 1 28S13.112 1 28 1s27 12.112 27 27-12.112 27-27 27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 23.617c-2.417 0-4.383 1.966-4.383 4.383s1.966 4.383 4.383 4.383 4.383-1.966 4.383-4.383-1.966-4.383-4.383-4.383m0 12.273c-4.35 0-7.89-3.54-7.89-7.89s3.54-7.89 7.89-7.89 7.89 3.54 7.89 7.89-3.54 7.89-7.89 7.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 44.656c-9.184 0-16.656-7.472-16.656-16.656 0-1.955.336-3.87 1-5.693a.877.877 0 0 1 1.648.599A14.8 14.8 0 0 0 13.097 28c0 8.217 6.686 14.903 14.903 14.903S42.903 36.217 42.903 28 36.217 13.097 28 13.097c-1.905 0-3.767.36-5.534 1.067a.877.877 0 0 1-.652-1.628A16.6 16.6 0 0 1 28 11.344c9.184 0 16.656 7.472 16.656 16.656S37.184 44.656 28 44.656"
  }))));
};
export default SvgIcnTypeDotButton;